import React from "react";
import GarpacReportsContainer from "./GarpacReportsContainer";

const GarpacReports = () => {
  return <GarpacReportsContainer />;
};

export default GarpacReports;